import React, {useState} from 'react';

const ValuesContext = React.createContext({
  values: {},
});

export const ValuesContextProvider = ({children}) => {
  const [values, setValues] = useState({
    370: '0.00',
    371: '0.00',
    373: '0.00',
    211: '0.00',
    212: '0.00',
    213: 'BAT_STARTUP_STATE',
    221: 'Off',
    222: '10',
    231: '0.00',
    232: '0.00',
    233: '0',
    241: '0.00',
    242: '0.00',
    243: '0.00',
    244: '0.00',
    245: '0.00',
    246: '0.00',
    3441: '0',
    3442: '0',
    3443: '0',
    3444: '0',
    3445: '0',
    3446: '0',
    3447: '0',
    3448: '0',
    3449: '0',
    3450: '0',
    3451: '0',
    3452: '0',
    3453: '0',
    3454: '0',
    363: '0',
    364: '0',
    365: '0',
    366: '0',
    367: '0',
    368: '0',
    381: 'Mass Flow Rate',
    382: 'gram/s',
    383: '0.00',
    384: '100.0',
    4221: '0',
    5111: '1',
    5113: 'NOC_15C',
    51121: '1',
    51122: '30.0',
    51123: '-1.0',
    51124: '0',
    51125: '1.0',
    51126: 'Off',
    51151: 'Off',
    51152: '0.00',
    51153: '0',
    5121: '0.64',
    5122: 'Off',
    51231: 'gram/s',
    51232: '0.00 gram/s',
    51234: '1.00',
    51241: 'Off',
    51242: 'L/s',
    51243: '0.0',
    51245: '0.001205 g/cm3',
    51246: '1.00',
    5131: 'g/cm3',
    5133: '1.28',
    5134: '0.2 g/cm3',
    5135: '1.00',
    5136: '5.0',
    5137: '0.00',
    5138: '0.00',
    5141: '°C',
    5143: '4.8',
    5144: 'Off',
    51441: 'Off',
    51442: '0.00 °C',
    5144311: 'None',
    5144312: 'POLL_NONE',
    5144313: '0x38, 0xF3, 0x85, 0x82, 0x08, 0x20, 0x00, 0x00',
    5144321: 'None',
    5144322: 'POLL_NONE',
    5144323: '0x38, 0xF3, 0x85, 0x82, 0x08, 0x20, 0x00, 0x00',
    51531: 'TZ_greenwich',
    51532: '8',
    515311: 'TZ_greenwich',
    515312: '0.00',
    5161: 'psi',
    5162: '0.00',
    5163: '0.00',
    5164: '0.00',
    5165: '0.00',
    5166: '1.37895 psi',
    5167: 'Off',
    51671: 'Off',
    51672: '0.00 psi',
    5167321: 'None',
    5167322: 'POLL_NONE',
    5167323: '0x38, 0xF3, 0x85, 0x82, 0x08, 0x20, 0x00, 0x00',
    5167331: 'None',
    5167332: 'POLL_NONE',
    5167333: '0x38, 0xF3, 0x85, 0x82, 0x08, 0x20, 0x00, 0x00',
    51711: 'Mass Flow Rate',
    51712: 'Forward',
    51713: '0',
    517111: 'Volume Flow Rate',
    517112: 'Forward',
    517113: '0',
    517121: 'Referred Volume Flow',
    517122: 'Forward',
    517123: '0',
    517131: 'GasVol Fwd Total',
    517132: 'Forward',
    517133: '0',
    517141: 'StdVol Fwd Total',
    517142: 'Forward',
    517143: '0',
    517151: 'NetMass Fwd Total',
    517152: 'Forward',
    517153: '0',
    517161: 'NetVol Fwd Total',
    517162: 'Forward',
    517163: '0',
    517171: 'Mass Fwd Inv',
    517172: 'Forward',
    517173: '0',
    517181: 'Vol Fwd Inv',
    517182: 'Forward',
    517183: '0',
    517191: 'CorrVol Fwd Inv',
    517192: 'Forward',
    517193: '0',
    511711: 'GasVol Fwd Inv',
    511712: 'Forward',
    511713: '0',
    512711: 'StdVol Fwd Inv',
    512712: 'Forward',
    512713: '0',
    513711: 'NetMass Fwd Inv',
    513712: 'Forward',
    513713: '0',
    514711: 'NetVol Fwd Inv',
    514712: 'Forward',
    514713: '0',
    51811: 'm/s',
    5201: 'Off',
    5202: 'API_TABLE_53A',
    5203: '0.001 °C',
    5204: '15.0 °C',
    5205: 'Off',
    5206: '0.00 psi',
    5211: 'Off',
    52121: 'ED_Mode_DensAtRef',
    52122: '0',
    521232: 'On',
    521233: 'On',
    521234: 'On',
    52131: 'UNIT_PctSol_wt',
    52132: 'UNIT_PctSol_wt',
    52133: 'UNIT_PctSol_wt',
    52134: 'UNIT_PctSol_wt',
    52135: 'UNIT_PctSol_wt',
    5221: '0x18, 0x93, 0x84, 0x24, 0xE1, 0xE0, 0x4C, 0x53, 0x93, 0x3D, 0x28, 0x20',
    5222: 'Off',
    5223: '0.00 gram/s',
    5224: '0.00',
    5225: '0.00',
    5226: '0.00',
    5227: '0.5',
    52311: 'Mass Flow Rate',
    52312: '999999999.00',
    52313: '0.00',
    52314: '1',
    52315: '1',
    52316: 'BAT_BYPERCENT',
    52317: 'On',
    52318: 'Off',
    52319: 'Off',
    52320: '1.0',
    52321: 'Off',
    52331: 'Batch_Comp_AOC',
    52332: '0.00',
    5241: 'Off',
    5251: 'MJ/h',
    5252: 'UNIT_MJ_m3',
    520111: '[special]',
    520112: '[special]',
    520113: '0x19, 0x4B, 0x70, 0xC3, 0x0C, 0x20, 0x00, 0x00',
    520114: "F','T','-','0','0','0','0'",
    520115: '0x34, 0x14, 0xD4, 0x15, 0x28, 0x12, 0x15, 0x31, 0x54',
    5201111: 'TZ_greenwich',
    5201112: '[special]',
    52011111: 'TZ_greenwich',
    52011112: '0.00',
    531: 'MAO1',
    532: 'MAO2',
    533: 'FO1',
    534: 'DO3',
    535: 'RS-485',
    5311: 'MAO1',
    5313: 'Active',
    5321: 'MAO2',
    5323: 'Passive',
    5353: 'COMM_FAULT_NONE',
    541: 'English',
    544: 'Off',
    545: '10',
    546: '250',
    547: 'On',
    548: '50',
    549: '50',
    5501: '200',
    5502: '200',
    5503: '200',
    5504: '200',
    5431: '1',
    5432: '1',
    5433: '1',
    5434: '1',
    5435: '1',
    5436: '1',
    5437: '1',
    5438: '1',
    5439: '1',
    5440: '1',
    5441: '1',
    5442: '1',
    5443: '1',
    5444: '1',
    5445: '1',
    5446: '1',
    5447: '1',
    5448: '1',
    5449: '1',
    5450: '1',
    5451: '1',
    5452: '1',
    5453: '1',
    5454: '1',
    5455: '1',
    5456: '1',
    5457: '1',
    5458: '1',
    5459: '1',
    5460: '1',
    5461: '1',
    5462: '1',
    5463: '1',
    5464: '1',
    5465: '1',
    5466: '1',
    5467: '1',
    5468: '1',
    5469: '1',
    5470: '1',
    5471: '1',
    5472: '1',
    5473: '1',
    5474: '1',
    5475: '1',
    5476: '1',
    5477: '1',
    5478: '1',
    5479: '1',
    5480: '1',
    5481: '1',
    5511: '0',
    5512: 'MAO1',
    5513: 'MAO2',
    5514: 'FO1',
    5515: 'DO3',
    5516: 'RS-485',
    5517: 'COMM_FAULT_NONE',
    552111: '0',
    552112: '0',
    552113: '0',
    55221: '0',
    55231: '0',
    55232: '0',
    552331: '1',
    552411: '1',
    55251: '0',
    55252: '0',
    552531: '1',
    55261: '0',
    55262: '0',
    552631: '1',
    55271: '0',
    55272: '0',
    552731: '1',
    552732: '1',
    552733: '1',
    552734: '1',
    552735: '1',
    552736: '1',
    552737: '1',
    552738: '1',
    552739: '1',
    552740: '1',
    552741: '1',
    552742: '1',
    55281: '0',
    55282: '0',
    552831: '1',
    552832: '1',
    552833: '1',
    552834: '1',
    552835: '1',
    552836: '1',
    552837: '1',
    55291: '0',
    55292: '0',
    552931: '1',
    552932: '1',
    552933: '1',
    552934: '1',
    552935: '1',
    552936: '1',
    552937: '1',
    552938: '1',
    55301: '0',
    55302: '0',
    553031: '1',
    553032: '1',
    553033: '1',
    55311: '0',
    55312: '0',
    553131: '1',
    553132: '1',
    55321: '0',
    55322: '0',
    553231: '1',
    55331: '0',
    55332: '0',
    553331: '1',
    55311111: 'Mass Flow Rate',
    55311112: '0.00',
    55311113: '0.05',
    55311121: 'PV_DENSITY',
    55311122: 'PC_LO',
    55311123: '0.0f, 0.0f, 0.0f, 0.0f,',
    55311124: '0.0f, 0.0f, 0.0f, 0.0f,',
    553111251: 'None',
    553111252: 'None',
    553111253: 'None',
    553111254: 'None',
    553111255: 'None',
    553111256: 'None',
    553111257: 'None',
    553111258: 'None',
    553111259: 'None',
    553111260: 'None',
    553111261: 'None',
    553111262: 'None',
    553111263: 'None',
    553111264: 'None',
    553111265: 'None',
    553111266: 'None',
    553111267: 'None',
    553111268: 'None',
    553111269: 'None',
    553111270: 'None',
    553111271: 'None',
    553111272: 'None',
    553111273: 'None',
    553111274: 'None',
    553111275: 'None',
    553111276: 'None',
    553111277: 'None',
    553111278: 'None',
    553111279: 'None',
    553111280: 'None',
    553111281: 'None',
    553111282: 'None',
    553111283: 'None',
    553111284: 'None',
    553111285: 'None',
    553111286: 'None',
    553111287: 'None',
    55311126111: 'Off',
    55311126211: 'Off',
    55311126311: 'Off',
    55311126411: 'Off',
    55311126511: 'Off',
    55311126611: 'Off',
    55311126711: 'Off',
    55311126811: 'Off',
    55311126911: 'Off',
    561: 'CURVED_TUBE',
    562: '0',
    563: '0.00',
    564: '1.0',
    565: '1000.0',
    566: '50000.0',
    567: '4.44',
    568: '0.00',
    569: '0.00',
    570: '0.00',
    571: '0.00',
    572: '0.00',
    573: '0.00',
    574: '1.00',
    575: '0.00',
    5711: '[special]',
    5712: '[special]',
    5713: '1',
    5714: 'Totalizer 1',
    5715: 'Inventory 1',
    5716: 'None',
    5717: 'None',
    581: 'WA_NTEP',
    583: '[special]',
    584: '[special]',
    585: '[special]',
    586: '[special]',
    587: 'Off',
    58111: '0',
    58112: '0',
    58113: '0',
    58114: '0',
    58115: '0',
    58116: '0',
    58117: '0',
    58118: '0',
    58119: '0',
    58120: '0',
    58121: '0',
    58122: '0',
    58123: '0',
    58124: '0',
    58125: '0',
    58126: '0',
    58127: '0',
    58128: '0',
    58129: '0',
    58130: '0',
    58131: '0',
    58132: '0',
    58133: '0',
    58134: '0',
    58135: '0',
    58136: '0',
    58137: '0',
    58138: '0',
    58139: '0',
    58140: '0',
    58141: '0',
    58142: '0',
    58143: '0',
    58144: '0',
    58145: '0',
    58146: '0',
    58147: '0',
    58148: '0',
    58149: '0',
    58150: '0',
    58151: '0',
    58152: '0',
    58153: '0',
    592: 'On',
    5911: 'UI_SECURITY_None',
    5912: 'Off',
    5913: 'On',
    59141: 'On',
    59142: 'On',
    59143: 'Off',
    59144: 'Off',
    59145: 'Off',
    601: '0',
    602: '0',
    603: "'N','O',' ','M'",
    604: "'N','O',' ','M'",
    63267: '0.00',
    63268: '0.00',
    63269: '0.00',
    63311: '0.00',
    63312: '1000.0',
    63321: '1.0',
    63322: '50000.0',
    651: 'Off',
    6556: 'SIM_PV_Fixed',
    6534: '0.00 gram/s',
    6535: '0.00 gram/s',
    6536: '0.20 gram/s',
    6537: '1.0',
    6541: 'SIM_PV_Fixed',
    6545: '0.00 g/cm3',
    6546: '0.00 g/cm3',
    6547: '5.00 g/cm3',
    6548: '1.0',
    6557: 'SIM_PV_Fixed',
    6552: '0.00 °C',
    6553: '0.00 °C',
    6554: '450.0 °C',
    6555: '10.0',
    661: 'MAO1',
    662: 'MAO2',
    663: 'FO1',
    664: 'DO3',
    691: '0',
    862: 'Off',
    8675: 'SIM_PV_Fixed',
    8653: '0.0f gram/s',
    8654: '0.0f gram/s',
    8655: '0.2f gram/s',
    8656: '1.0',
    8660: 'SIM_PV_Fixed',
    8664: '0.0f g/cm3',
    8665: '0.0f g/cm3',
    8666: '5.0f g/cm3',
    8667: '1.0f',
    8676: 'SIM_PV_Fixed',
    8671: '0.0f °C',
    8672: '0.0f °C',
    8673: '450.f °C',
    8674: '10.0f',
    53121: 'Mass Flow Rate',
    53122: 'Normal',
    53123: '-0.2',
    53124: '0.2',
    53125: '0.0',
    53126: '0.0',
    53127: 'Downscale',
    53128: '2.0',
    53141: '0',
    53143: 'Off',
    53146: '0, 0, 0',
    53147: '0, 0, 0',
    53148: '0, 0, 0',
    531441: 'Mass Flow Rate',
    531442: 'Density',
    531443: 'Volume Flow Rate',
    531444: 'Temperature',
    5314513: '0x38, 0xF3, 0x85, 0x82',
    5314523: '0x38, 0xF3, 0x85, 0x82',
    5312111: 'Mass Flow Rate',
    5312112: 'Normal',
    5312113: '-0.2',
    5312114: '0.2',
    5312115: '0.0',
    5312116: '0.0',
    5312117: 'Downscale',
    5312118: '2.0f',
    5331: 'FO1',
    5333: 'Passive',
    5412111: 'Temperature',
    5412112: 'Normal',
    5412113: '-240.0',
    5412114: '450.0',
    5412115: 'NAN',
    5412116: '0.0',
    5412117: 'Downscale',
    5412118: '2.0',
    5341: 'DO3',
    5343: 'Active',
    5512111: 'Flow Direction',
    5512112: 'Active High',
    5512113: 'None',
    53511: 'INTER_NONE',
    535121: '192',
    535122: '168',
    535123: '192',
    535124: '168',
    535132: 'Off',
    535133: '0',
    5351402: '1',
    5351403: 'PRINT_DoubleHeight',
    5351341: '1',
    5351342: '1',
    5351343: 'PRINT_WithFlow',
    5351344: 'Off',
    5351345: 'Off',
    5351362: '1',
    5351363: 'PRINT_DoubleHeight',
    5351372: '1',
    5351373: 'PRINT_DoubleHeight',
    5351382: '1',
    5351383: 'PRINT_DoubleHeight',
    5351392: '1',
    5351393: 'PRINT_DoubleHeight',
    535151: 'BAUD_9600',
    535152: 'PARITY_ODD',
    535153: '8',
    535154: '1',
    535155: '10',
    535156: '32',
    535157: '1',
    53521: '1',
    53522: 'FLOAT_34_12',
    53523: 'DOUBLE_1234_5678',
  });

  const onUpdate = (prop, value) => setValues(state => ({...state, [prop]: value}));

  return (
    <ValuesContext.Provider value={{values, onUpdateValues: onUpdate}}>
      {children}
    </ValuesContext.Provider>
  );
};
export default ValuesContext;
